// extracted by mini-css-extract-plugin
export var container = "_6v-0";
export var infoButton = "_6v-1";
export var label = "_6v-3";
export var labelExpanded = "_6v-4";
export var price = "_6v-5";
export var priceExpanded = "_6v-6";
export var title = "_6v-2";